/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useSenderEmailSettings } from "./utils/use-sender-email-settings";
import { Button } from "@/components/ui/button";
import { PlusIcon, Trash2Icon } from "lucide-react";
import { KeyUpdateInput } from "./utils/key-update-input";
import { SenderEmailForm } from "./utils/sender-email-form";
import { useState } from "react";

export const SenderEmailSettings = ({
  value,
  onChange,
  label,
  setIsDisable,
}: any) => {
  // const { data, mutationHandling } = useSenderEmailSettings({
  //   value,
  //   onChange,
  // });

  const [isReadMore, setIsReadMore] = useState(false);

  const onChangeHandle = (type: any, formValue: any, index: number) => {
    console.log({ type, value, index });
    const tempData = value.map((item: any, i: number) => {
      if (i === index) {
        return { ...item, [type]: formValue };
      }
      return item;
    });
    console.log({ value, tempData });
    onChange(tempData);
    // setIsReadMore(!isReadMore);
  };

  const onDelete = (index: number) => {
    const tempData = value.filter((_item: any, i: number) => i !== index);
    onChange(tempData);
  };

  const onAddNewRecord = () => {
    if (Array.isArray(value)) {
      onChange([
        {
          email: "",
          supported_doc_types: [],
        },
        ...value,
      ]);
    } else {
      onChange([
        {
          email: "",
          supported_doc_types: [],
        },
      ]);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between ">
        {label}

        {!Array.isArray(value) || value?.length === 0 ? null : (
          <Button
            type="button"
            variant={"outline"}
            // disabled={Object.keys(data).includes("")}
            className="    "
            onClick={() => onAddNewRecord()}
            // onClick={() => mutationHandling({ type: "add", payload: {} })}
          >
            <PlusIcon /> Add Sender email
          </Button>
        )}
      </div>
      {!Array.isArray(value) || value?.length === 0 ? (
        <div className="flex flex-col gap-2 mt-1 items-center justify-center border h-[100px] rounded-md">
          <Button
            type="button"
            variant={"outline"}
            // disabled={Object.keys(data).includes("")}
            className="bg-black text-white"
            onClick={() => onAddNewRecord()}

            // onClick={() => mutationHandling({ type: "add", payload: {} })}
          >
            <PlusIcon /> Add Sender email
          </Button>
        </div>
      ) : (
        <div className="flex flex-col gap-2 mt-1 form-table">
          <table>
            <thead>
              <tr>
                <th className="w-[300px]">Sender email</th>
                <th>Supported document types</th>
                <th className="!text-center w-[100px]">Action</th>
              </tr>
            </thead>

            <tbody>
              {value?.map((item: any, index: number) => {
                if (!isReadMore && index >= 2) return null; // 👈 skip extra items

                return (
                  <tr key={index + item.emailx}>
                    <td className="align-baseline">
                      <KeyUpdateInput
                        // list={Object.keys(data)}
                        value={item.email}
                        setIsDisable={setIsDisable}
                        onChange={(prop) => {
                          onChangeHandle("email", prop, index);

                          // mutationHandling({
                          //   type: "update-key",
                          //   payload: {
                          //     key: email,
                          //     data: prop,
                          //   },
                          // });
                        }}
                      />
                    </td>
                    <SenderEmailForm
                      value={item.supported_doc_types}
                      onChange={(prop: any) => {
                        onChangeHandle("supported_doc_types", prop, index);
                      }}
                      dataKey={"supported_doc_types"}
                      // disabled={key === ""}
                    />
                    <td className="align-baseline text-center ">
                      <Button
                        type="button"
                        size={"icon"}
                        variant={"outline"}
                        className="border-red-100 text-red-500"
                        onClick={() => onDelete(index)}
                        // onClick={() =>
                        //   mutationHandling({
                        //     type: "delete",
                        //     payload: { key: key },
                        //   })
                        // }
                      >
                        <Trash2Icon />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>

            {/* <tbody>
              {data &&
                Object.entries(data)
                  .slice(0, isReadMore ? Object.entries(data).length : 2) // 👈 limit logic here
                  .map(([key, value]: any, index: number) => {
                    return (
                      <tr key={index + "-" + key}>
                        <td className="align-baseline">
                          <KeyUpdateInput
                            list={Object.keys(data)}
                            value={key}
                            setIsDisable={setIsDisable}
                            onChange={(prop) =>
                              mutationHandling({
                                type: "update-key",
                                payload: {
                                  key: key,
                                  data: prop,
                                },
                              })
                            }
                          />
                        </td>
                        <SenderEmailForm
                          value={value}
                          mutationHandling={mutationHandling}
                          dataKey={key}
                          disabled={key === ""}
                        />
                        <td className="align-baseline text-center ">
                          <Button
                            type="button"
                            size={"icon"}
                            variant={"outline"}
                            className="border-red-100 text-red-500"
                            onClick={() =>
                              mutationHandling({
                                type: "delete",
                                payload: { key: key },
                              })
                            }
                          >
                            <Trash2Icon />
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
            </tbody> */}

            <tfoot>
              <tr>
                {value?.length <= 2 ? null : (
                  <td colSpan={3} className="text-right border ">
                    <Button
                      type="button"
                      variant={"link"}
                      onClick={() => setIsReadMore(!isReadMore)}
                    >
                      {isReadMore ? (
                        "View Less"
                      ) : (
                        <>+{value?.length - 2} more</>
                      )}
                    </Button>
                  </td>
                )}
              </tr>
            </tfoot>
          </table>
        </div>
      )}
      <pre>
        {/* {JSON.stringify(value, null, 2)} */}
        {/* {JSON.stringify(data, null, 2)} */}
      </pre>
    </div>
  );
};
